import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";

const initState = {
  eventName: '',
  eventDate: '',
  eventType: null,
  eventTopic: '',
  isPublished: false,
  isPrivate: false,
}

export const EditEventGalleryFormData = {
  name: "EditEventGalleryFormData",
  initialState: initState,
  section: [
    {
      title: "EditEventGalleryFormData",
      row: {},
      style: {
        sectionStyle: "row verticle-form",
      },
      rowGroup: [
        {
          groupLabel: "EditEventGalleryFormData", // Group for contact fields
          style: {
            groupStyle: "col-lg-12 col-md-12 mb-3",
          },
          groupWrapper: <div className="row"></div>, // Wrapper HTML or Component
          fields: [
            {
              id: "eventName",
              label: "Event",
              Field_Name: "Event",
              fieldType: FormFieldTypes.INPUT,
              dataField: "eventName",
              fieldSetting: {
                allowSpace: true,
              },
              validation: [{ type: validationTypes.REQUIRE }],
              style: {
                containerCss: "col-lg-6 col-md-6 validation-left-0 mb-3",
              },
            },
            {
              id: "eventDate",
              label: "Date",
              Field_Name: "Date",
              fieldType: FormFieldTypes.DATEPICKER,
              dataField: "eventDate",
              fieldSetting: {
                placeholder: "",
              },
              // validation: [{ type: validationTypes.REQUIRE }],
              style: {
                containerCss: "col-lg-6 col-md-6 validation-left-0 mb-3",
              },
            },
            {
              id: "eventType",
              label: "Entry Type",
              Field_Name: "Entry Type",
              fieldType: FormFieldTypes.SELECT,
              dataField: "eventType",
              fieldSetting: {
                placeholder: "Select",
                options: [
                  // { label: "City 1", value: 1 },
                  // { label: "City 2", value: 2 },
                  // { label: "City 3", value: 3 },
                ],
              },
              validation: [{ type: validationTypes.REQUIRE }],
              style: {
                containerCss: "col-lg-6 col-md-6 validation-left-0 mb-3",
              },
            },
            {
              id: "eventTopic",
              label: "Entry Topic",
              Field_Name: "Entry Topic",
              fieldType: FormFieldTypes.SELECT,
              dataField: "eventTopic",
              fieldSetting: {
                isMultiSelect: true,
                placeholder: "Select",
                options: [
                  // { label: "City 1", value: 1 },
                  // { label: "City 2", value: 2 },
                  // { label: "City 3", value: 3 },
                ],
              },
              validation: [{ type: validationTypes.REQUIRE }],
              style: {
                containerCss: "col-lg-6 col-md-6 validation-left-0 mb-3",
              },
            },
            {
              id: "isPublished",
              label: "Is Published",
              Field_Name: "Is Published",
              fieldType: FormFieldTypes.CHECKBOX,
              dataField: "isPublished",
              fieldSetting: {
                options: [],
              },
              style: {
                containerCss:
                  "col-lg-6 col-md-6 radioStyle  mb-3 normal-checkbox",
              },
            },
            // {
            //   id: "isPrivate",
            //   label: "Is Private",
            //   Field_Name: "Is Private",
            //   fieldType: FormFieldTypes.CHECKBOX,
            //   dataField: "isPrivate",
            //   fieldSetting: {
            //     options: [],
            //   },
            //   style: {
            //     containerCss:
            //       "col-lg-6 col-md-6 ml-auto radioStyle  mb-3 normal-checkbox",
            //   },
            // },
          ],
        },
      ],
    },
  ],
};